import { render, staticRenderFns } from "./NoClose-issue.vue?vue&type=template&id=2b150030"
import script from "./NoClose-issue.vue?vue&type=script&lang=js"
export * from "./NoClose-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports